import { AutoKeyFacet } from '../AutoKeyFacet';

/**
 * @internal
 */
export const itemsScopeItemKeyFacet = new AutoKeyFacet('itemsScope');

/**
 * @public
 */
export function getNextItemsScopeItemKey(): string {
  return itemsScopeItemKeyFacet.serializeNext();
}
